module.exports = __webpack_public_path__ + "media/email.610f3a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/coffee/assets/email.svg
// module id = ./src/templates/coffee/assets/email.svg
// module chunks = 0